<div class="container-no-vehicles d-flex flex-column align-items-center justify-content-center flex-1">
    <i class="bg-icon-danger-light bi-car-front-fill default-icon p-1"></i>
    <header class="fs-rem-125 fw-500 mb-2 mt-1">{{'BOOKINGS_MODAL.NO_VEHICLES_FOUND_TITLE' | translate}}</header>

    @if (bookingStatus !== BookingStatus.STATUS_CLOSED_NO_VEHICLES) {
        <p class="text-muted text-center fs-rem-085">{{'BOOKINGS_MODAL.NO_VEHICLES_FOUND_CONTENT' | translate}}</p>
        <p class="text-danger text-center fs-rem-085">{{'BOOKINGS_MODAL.ALERT_CLOSE_BOOKING' | translate}}</p>
    }
    @else {
        <p class="text-muted text-center fs-rem-085">{{'BOOKINGS_MODAL.NO_VEHICLES_FOUND_CONTENT_CLOSED' | translate}}</p>
    }        
    
    <div class="d-flex gap-2 align-items-center justify-content-center mt-4">
        @if (bookingStatus !== BookingStatus.STATUS_CLOSED_NO_VEHICLES) {
            <button class="btn-outline-gs-danger d-flex gap-2" (click)="closeBooking.emit()">
                <i class="bi bi-x-circle"></i>
                {{'BOOKINGS_MODAL.NO_VEHICLES_FOUND_BUTTON' | translate}}
            </button>
        }
        <button class="btn-outline-gs-primary d-flex gap-2" (click)="viewBookingDocument.emit()">
            <i class="bi bi-download"></i>
            {{'ACTIONS.VIEW_DOCUMENT' | translate}}
        </button>
    </div>
</div> 